// extracted by mini-css-extract-plugin
export var boldText = "_6l-4";
export var checkboxContainer = "_6l-6";
export var closeIcon = "_6l-i";
export var container = "_6l-0";
export var drawer = "_6l-8";
export var drawerContent = "_6l-9";
export var extraSmallText = "_6l-5";
export var fulfillmentGroupTable = "_6l-e";
export var largeText = "_6l-3";
export var loadingSpinnerContainer = "_6l-j";
export var mediumText = "_6l-2";
export var narrow = "_6l-f";
export var notificationLink = "_6l-l";
export var packageCheckIconContainer = "_6l-7";
export var slideoutHeaderActions = "_6l-g";
export var slideoutHeaderActionsShifted = "_6l-h";
export var slideoutHeaderContainer = "_6l-a";
export var slideoutModal = "_6l-c";
export var stickyHeaderWrapper = "_6l-b";
export var table = "_6l-k";
export var tableContainer = "_6l-d";
export var tertiaryText = "_6l-1";